export const buttons = [
  {
    text: "London",
    categoryUrl: "/london",
  },
  {
    text: "UK",
    categoryUrl: "/all",
  },
];
